module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"groups":"@:labels.groups","selectUsersGroups":"Select Users or Groups","users":"@:labels.users"},"fr":{"groups":"@:labels.groups","selectUsersGroups":"Choisir les utilisateurs où les groupes","users":"@:labels.users"}}')
  delete Component.options._Ctor
}
